import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import { StyledEngineProvider } from '@mui/material/styles';

import App from './App';
import { ProtectedRoute } from '@/components/containers';
import { BaseLayout } from '@/components/layouts';
import { CallbackPage, HomePage } from "@/pages";
import './styles/styles.scss';



const container = document.getElementById('root')! as HTMLElement;
const root = createRoot(container);

const router = createBrowserRouter(
  [
    {
      Component: App,
      children: [
        {
          path: "/",
          element: <ProtectedRoute component={BaseLayout} />,
          children: [
            {
              path: '',
              Component: HomePage
            },
            {
              path: 'callback',
              Component: CallbackPage,
            },
          ]
        },
      ]
    },
  ],
  {
    future: {
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_relativeSplatPath: true,
      v7_skipActionErrorRevalidation: true,
    },
  }
);

root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </StyledEngineProvider>
  </React.StrictMode>
);
